module.exports = __webpack_public_path__ + "img/service_1.a0ec3ed9.png";